import React from 'react';
import { PatentCitingSection } from '../../components/citing/PatentCiting';
import { RecommendationBar } from '../../components/Shared';
import { useWritingForm } from '../../hooks/useWritingForm';
import { SourceType } from '../../types';
import { PatentContributorFunctions } from './constants';
import { ContributorSection } from '../../components/ContributorSection';
var PatentForm = function PatentForm() {
  useWritingForm(SourceType.PATENT);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(PatentCitingSection, null), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: PatentContributorFunctions
  }));
};
export default PatentForm;